var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M11.334 16a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.334 0Zm9 0a4.333 4.333 0 1 1-8.667 0 4.333 4.333 0 0 1 8.667 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M16.994 12.817a3.308 3.308 0 0 0-.593-.127.333.333 0 0 1 .08-.662c.242.03.48.08.711.152a.333.333 0 0 1-.198.637Zm-2.155.057c.189-.07.384-.123.585-.158a.333.333 0 0 0-.115-.656c-.24.041-.475.105-.702.19a.333.333 0 1 0 .232.624Zm-.799.43a3.36 3.36 0 0 0-.455.4.333.333 0 1 1-.484-.46c.168-.176.35-.337.547-.48a.333.333 0 0 1 .393.54Zm-1.236 1.747c.057-.194.133-.382.224-.562a.333.333 0 1 0-.594-.303c-.11.216-.2.443-.27.676a.333.333 0 1 0 .64.19Zm-.137.99a3.3 3.3 0 0 0 .053.554.333.333 0 1 1-.656.118c-.04-.218-.06-.44-.063-.667v-.106a.333.333 0 1 1 .666.01v.089Zm.687 1.986a3.334 3.334 0 0 1-.324-.512.333.333 0 0 0-.593.303c.11.217.24.422.388.615a.333.333 0 0 0 .53-.406Zm.654.646c.163.121.336.227.517.317a.333.333 0 0 1-.296.598 4.007 4.007 0 0 1-.62-.38.333.333 0 0 1 .4-.535Zm2.07.67a.333.333 0 0 0-.078-.01c-.204 0-.406-.018-.604-.054a.333.333 0 0 0-.12.655c.238.044.48.066.724.066a.335.335 0 0 0 .094-.013c.03.007.061.01.094.009.244-.012.485-.045.72-.1a.333.333 0 1 0-.15-.649 3.333 3.333 0 0 1-.601.083.334.334 0 0 0-.078.013Zm0 0a.334.334 0 0 0 .016.644.334.334 0 0 0-.015-.644Zm1.758-6.126c.169.112.327.238.473.379a.333.333 0 1 0 .462-.481 4.016 4.016 0 0 0-.568-.454.333.333 0 1 0-.367.556Zm1.3 1.647a3.31 3.31 0 0 0-.258-.548.333.333 0 1 1 .575-.338c.122.21.226.43.309.659a.333.333 0 0 1-.627.227Zm.194.968a3.377 3.377 0 0 1-.026.617.333.333 0 1 0 .66.09 4.082 4.082 0 0 0 .031-.74.333.333 0 0 0-.666.033Zm-.564 2.03c.113-.168.21-.346.292-.531a.333.333 0 1 1 .61.266 4 4 0 0 1-.35.638.333.333 0 0 1-.552-.373Zm-.614.684c-.155.13-.32.247-.496.348a.333.333 0 1 0 .331.578c.211-.12.41-.26.596-.417a.333.333 0 0 0-.43-.51Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 16.873-1.11.794.416-1.27-.972-.794h1.25l.416-1.27.417 1.27h1.25l-.972.794.416 1.27-1.11-.794Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M14.714 13.286a3 3 0 1 0 2.572 0 .333.333 0 1 0-.286.602 2.333 2.333 0 1 1-2 0 .333.333 0 1 0-.286-.602Z"
    }
  )
), "SvgComponent"), SvgFlagPry = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagPry_default = SvgFlagPry;
export {
  FlagPry_default as default
};
